import { render, staticRenderFns } from "./MenuItemComponent.vue?vue&type=template&id=fe32127c&scoped=true"
import script from "./MenuItemComponent.vue?vue&type=script&lang=js"
export * from "./MenuItemComponent.vue?vue&type=script&lang=js"
import style0 from "./MenuItemComponent.vue?vue&type=style&index=0&id=fe32127c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe32127c",
  null
  
)

export default component.exports